// 숫자로 시작, 숫자·공백·`-·(·)` 만 허용. URL 스킴 인젝션(예: javascript:) 차단용.
// 탭·개행이 섞이지 않도록 \s 대신 일반 공백만 허용한다.
const TELEPHONE_ALLOWED_PATTERN = /^[+]?[\d][\d \-()]{0,19}$/

/**
 * 이미지/링크 URL을 https로 보정한다.
 * - http:// 는 https:// 로 업그레이드 (CDN이 http로 내려와도 버리지 않음)
 * - 그 외 스킴(javascript:, data: 등)은 null 반환
 */
export const sanitizeHttpsUrl = (
  url: string | null | undefined
): string | null => {
  if (!url) return null
  if (url.startsWith('https://')) return url
  if (url.startsWith('http://')) return url.replace(/^http:\/\//, 'https://')
  return null
}

/**
 * 전화번호를 검증한다. 앞뒤 공백을 제거한 뒤 허용 패턴을 통과할 때만 반환한다.
 */
export const sanitizeTelephone = (
  value: string | null | undefined
): string | null => {
  if (!value) return null
  const trimmed = value.trim()
  return TELEPHONE_ALLOWED_PATTERN.test(trimmed) ? trimmed : null
}
